(function($) {
  // Use this variable to set up the common and page specific functions. If you
  // rename this variable, you will also need to rename the namespace below.
  var SM = {
    // All pages
    'common': { init: function() { CommonScript.Init(); }},
    'map': { init: function() { MapScript.Init(); }},
    'bike': { init: function() { BikeScript.Init(); }},
    'gallery': { init: function() { GalleryScript.Init(); }},
    'slider': { init: function() { SliderScript.Init(); }},
  };

  // The routing fires all common scripts, followed by the page specific scripts.
  // Add additional events for more control over timing e.g. a finalize event
  var UTIL = {
    fire: function(func, funcname, args) {
      var fire;
      var namespace = SM;
      funcname = (funcname === undefined) ? 'init' : funcname;
      fire = func !== '';
      fire = fire && namespace[func];
      fire = fire && typeof namespace[func][funcname] === 'function';

      if (fire) {
        namespace[func][funcname](args);
      }
    },
    loadEvents: function() {
      // Fire common init JS
      UTIL.fire('common');

      // firejs = $('section').data('js');
      firejs = null;
      $('section').each(function(){
        if ($(this).data('js') != null) {
          firejs = $(this).data('js');
          if( firejs != null ){
            firejs_parts = firejs.split('_');
            for(var i=0;i<firejs_parts.length;i++){
                UTIL.fire(firejs_parts[i]);
            }
          }
        }
      });

    }
  };

  $(document).ready(function(){
      UTIL.loadEvents();
  });

})(jQuery);
